import {Component, OnInit} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute} from '@angular/router';

import {BusinessProcessService} from '../../../../services/business-process.service';
import {CustomValidator} from '../../../../services/custom-validator';
import {LockStatus} from '../../../../Models/enum/lockStatus';
import {Utils} from '../../../../services/utils';
import {DesignElementType} from '../../../../Models/enum/designElementType';
import {WebClientConfigurationService} from '../../../../services/configuration/web-client-configuration.service';
import {ElementLock} from '../../../../Models/elementLock';
import {LibraryItem} from '../../../../Models/parallelDesign/libraryItem';
import {LibraryItemType} from '../../../../Models/enum/libraryItemType';
import {GenericModalService} from '../../../../services/generic-modal.service';
import Swal from "sweetalert2";

@Component({
  selector: 'app-manage-locked-elements',
  templateUrl: './manage-locked-elements.component.html',
  styleUrls: ['./manage-locked-elements.component.css']
})
export class ManageLockedElementsComponent implements OnInit {

  utilsFunction = Utils;
  bpId: number;
  bpName: string;
  bpVersion: number;

  inscription: Subscription;

  elementsListSearch: string;
  manageLockedElementsForm: FormGroup;
  businessProcessLibrary: LibraryItem[];
  lockedElementsData = [];
  isRight = false;
  private userLogon = localStorage.getItem('userLogon');

  errorMessage: string;
  successMessage: string;
  pleaseWait = false;
  submitClick = false;
  showCurrentUserErrorMessage = false;

  get lockedElementsFormArray() {
    return this.manageLockedElementsForm.controls.lockedElements as FormArray;
  }

  constructor(private bpService: BusinessProcessService, private modalService: GenericModalService,
              private formBuilder: FormBuilder, private route: ActivatedRoute) { }

  ngOnInit() {
    this.errorMessage = '';
    this.successMessage = '';

    this.checkRights();
    this.createForm();

    this.inscription = this.route.params.subscribe(params => this.bpId = params['id']);

    if (!isNaN(parseFloat(this.bpId.toString()))) {

      this.pleaseWait = true;
      // recuperar informações do Processo de Negócio
      this.bpService.getLightBusinessProcess(this.bpId).subscribe( s => {
        this.bpName = s.name;
        this.bpVersion = s.version;
      }, error1 => {
        this.pleaseWait = false;
        this.errorMessage = error1;
        console.error(error1);
      });

      this.bpService.getBusinessProcessLibrary(this.bpId).subscribe(s => {
        this.businessProcessLibrary = s;
        console.log('library', this.businessProcessLibrary);
      }, error1 => {
        this.pleaseWait = false;
        this.errorMessage = error1;
        console.error(error1);
      });

      // recuperar os elementos bloqueados
      this.getLockedElement();

    } else {
      this.errorMessage = 'O parâmetro informado não é válido.';
    }
  }

  getLockedElement() {
    this.lockedElementsData = [];
    this.bpService.getElementLockStatus(this.bpId, LockStatus.checkedOut).subscribe(s => {
      // this.lockedElementsData = s;
      s.forEach((item) => {
        this.lockedElementsData.push({
          changeDate: item.changeDate,
          elementId: item.elementId,
          elementType: item.elementType,
          elementTypeDesc: this.getElementTypeDesc(item.elementType, item.elementId),
          lockStatus: item.lockStatus,
          name: item.name,
          user: item.user,
          checkRight: (item.user.logon === this.userLogon || this.isRight)
        });
      });

      this.addItems(this.lockedElementsData, this.lockedElementsFormArray);
      this.pleaseWait = false;
    }, error1 => {
      this.pleaseWait = false;
      this.errorMessage = error1;
      console.error(error1);
    });
  }

  selectAll(element) {
    const selectAllChecked = element.target.checked;

    const mappedFields = this.lockedElementsData.map(el => ( { elementId: el.elementId, checkRight: el.checkRight } ));
    mappedFields.forEach( checkAll => {
      const controlPosition = mappedFields.indexOf(checkAll);
      if (controlPosition !== -1 && checkAll.checkRight) {
        this.manageLockedElementsForm.get('lockedElements')['controls'][controlPosition].setValue(selectAllChecked);
      }
    });
  }

  onChbxChange(element, formArray: FormArray, formGroup: FormGroup) {
    const selectAll = (formArray.value.indexOf(false)) !== -1 || (formArray.value.indexOf(null) !== -1);
    if (element.target.id.indexOf('elements') !== -1) {
      this.manageLockedElementsForm.patchValue({
        checkboxSelectAllElements: !selectAll
      });
    }
  }

  private addItems(itemData: any[], itemFormArray: FormArray) {
    itemData.forEach(() => itemFormArray.push(new FormControl(false)));
  }

  createForm() {
    this.manageLockedElementsForm = this.formBuilder.group({
      lockedElements: new FormArray([], CustomValidator.minSelectedCheckboxes(1)),
      checkboxSelectAllElements: []
    });
  }

  onSave() {
    let alert: any;
    this.successMessage = '';
    this.errorMessage = '';
    this.submitClick = true;
    this.showCurrentUserErrorMessage = false;

    const selectedElements: ElementLock[] = this.manageLockedElementsForm.value.lockedElements
      .map((checked, i) => checked ? ( {
        changeDate: this.lockedElementsData[i].changeDate,
        elementId: this.lockedElementsData[i].elementId,
        elementType: this.lockedElementsData[i].elementType,
        lockStatus: this.lockedElementsData[i].lockStatus,
        name: this.lockedElementsData[i].name,
        user: this.lockedElementsData[i].user
      }) : null)
      .filter(v => v !== null);

    const msg = `<span>Você tem certeza que deseja desbloquear os elementos selecionados?</span>
                  <br />
                  <span>O desbloqueio implica no descarte de todas as alterações não salvas.</span>`;
    alert = this.modalService
      .showConfirmModal('Desbloquear elementos', msg);

    alert.then((result) => {
      if (result.value) {
        this.bpService.unlockElements(selectedElements).subscribe(s => {
          this.successMessage = 'Elemento(s) desbloqueado(s) com sucesso';
          setTimeout(() => {
            this.submitClick = false;
            this.successMessage = '';
            this.ngOnInit();
          }, 2500);
        }, error1 => {
          this.submitClick = false;
          this.errorMessage = error1;
          if (error1.indexOf('está bloqueado por outro usuário') !== -1){
            this.showCurrentUserErrorMessage = true;
          }
          console.error(error1);
        });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        this.submitClick = false;
      }
    });
  }

  filterLockedElements() {
    if (this.elementsListSearch !== '' && this.elementsListSearch !== undefined) {
      const filteredElements = this.lockedElementsData.filter(element => {
        return element.user.logon.toLowerCase().includes(this.elementsListSearch.toLowerCase());
      });

      this.lockedElementsData.forEach(element => {
        const id = 'trLockedElem' + element.elementId + element.elementType;
        if (filteredElements.includes(element)) {
          document.getElementById(id).removeAttribute('hidden');
        } else {
          document.getElementById(id).setAttribute('hidden', 'true');
        }
      });
    } else {
      this.lockedElementsData.forEach(element => {
        const id = 'trLockedElem' + element.elementId + element.elementType;
        document.getElementById(id).removeAttribute('hidden');
      });
    }
  }

  getElementTypeDesc(elemType: DesignElementType, elemId: number) {
    let desc = '';
    switch (elemType) {
      case 1: {
        desc = 'Processo de Negócio';
        break;
      }
      case 2: {
        desc = 'Estado';
        break;
      }
      case 3: {
        desc = 'Campo';
        break;
      }
      case 4: {
        if (this.businessProcessLibrary !== undefined && this.businessProcessLibrary.length > 0) {
          this.businessProcessLibrary.forEach((item) => {
            if (item.libraryItemId === elemId && item.itemType === LibraryItemType.flow) {
              switch (item.flowType) {
                case 1: {
                  desc = 'Fluxo de dados';
                  break;
                }
                case 2: {
                  desc = 'Fluxo de estados';
                  break;
                }
                case 3: {
                  desc = 'Fluxo de tela';
                  break;
                }
              }
            }
          });
        } else {
          desc = 'Fluxo nao identificado';
        }
        break;
      }
      case 5: {
        if (this.businessProcessLibrary !== undefined && this.businessProcessLibrary.length > 0) {
          this.businessProcessLibrary.forEach((item) => {
            if (item.libraryItemId === elemId && item.itemType === LibraryItemType.pageLayout) {
              switch (item.engineType) {
                case 1: {
                  desc = 'Layout de tela v1';
                  break;
                }
                case 2: {
                  desc = 'Layout de tela v2';
                  break;
                }
              }
            }
          });
        } else {
          desc = 'Layout nao identificado';
        }
        break;
      }
      case 6: {
        desc = 'Visão';
        break;
      }
    }
    return desc;
  }

  checkRights() {
    this.bpService.checkRights(536870912).subscribe(s => {
      this.isRight = s.length > 0;
    }, error1 => {
      this.errorMessage = error1;
      console.error(error1);
    });
  }
}
